import {
  Document,
  Page,
  PDFViewer,
  StyleSheet,
  Text,
  View,
} from '@react-pdf/renderer';
import { useNavigate } from 'react-router-dom';

import CloseIcon from '@mui/icons-material/Close';
import { Box, IconButton, Modal, Stack } from '@mui/material';
import { useEffect, useState } from 'react';

import { ToWords } from 'to-words';

import moment from 'moment';

import useAppContext from '@hooks/useAppContext';
import { useLazyGetCreditMemoQuery } from '../../../../../api/front-office/roomposting.api.rtk';
import { getColor } from '../../../../../assets/theme';
import LoadingComponent from '../../../../../components/animation/loading-component';
import ContainerTitle from '../../../../../components/ui/container-title';
import useToast from '../../../../../hooks/useToast';
import { useAppSelector } from '../../../../../store';
import { selectPropertyDetails } from '../../../../../store/selector/property.selector';
import { formatNumber } from '../../../../../utils/format';
import { RoomPostingCreditMemoVoucherIE } from '../../../interface/room-posting-interface';
const CreditMemoVoucher = ({
  cm_no = '0',
  isOpen = true,
  onClose,
}: {
  cm_no?: number | string;
  isOpen?: boolean;
  onClose?: () => void;
}) => {
  const navigate = useNavigate();
  const { paperBg } = getColor();

  const printedDate = moment().format('YYYY-MM-DD hh:mm A');

  const toWords = new ToWords({
    localeCode: 'en-PH',
    converterOptions: {
      currency: true,
      ignoreDecimal: false,
      ignoreZeroCurrency: false,
      doNotAddOnly: false,
      currencyOptions: {
        // can be used to override defaults for the selected locale
        name: 'Peso',
        plural: 'Pesos',
        symbol: '₱',
        fractionalUnit: {
          name: 'Centavo',
          plural: 'Centavos',
          symbol: '',
        },
      },
    },
  });
  //const [amountToWord, setAmountToWord] = useState<string>('');

  const [cmDetails, setCMDetails] = useState<RoomPostingCreditMemoVoucherIE[]>(
    [],
  );
  const handleCloseClick = () => {
    cm_no = 0;
    setCMDetails([]);
    // setAmountToWord('');
    !onClose && navigate(-1);
    onClose?.();
  };
  //for genpar details
  const {
    genpar: { getGenparValue },
  } = useAppContext();
  const busRegType = getGenparValue('bus_reg_type');
  const busTin = getGenparValue('bus_tin');

  //For Property Name selection
  const propertyDetails = useAppSelector(selectPropertyDetails);

  const { toast } = useToast();
  const [CMData] = useLazyGetCreditMemoQuery();

  useEffect(() => {
    if (cm_no !== '0') {
      (async () => {
        await CMData({
          cmID: cm_no,
        })
          .unwrap()
          .then((result) => {
            if (result.data) {
              setCMDetails(result?.data || []);
              // if (result?.data[0]?.gross) {
              //   setAmountToWord(
              //     toWords.convert(result?.data[0]?.gross).toUpperCase(),
              //   );
              // }
            }
          })
          .catch((error) => {
            toast({
              message: 'An error occurred on Credit Memo Slip.',
              severity: 'error',
            });
            console.error(error);
          });
      })();
    }
  }, [cm_no]);

  const styles = StyleSheet.create({
    page: { padding: 30, fontSize: 8, fontFamily: 'Roboto' },
    title: { fontWeight: 700, fontSize: 16, textAlign: 'center' }, // Bold
    subTitle: { fontSize: 8, textAlign: 'center' }, // Bold
    titleCode: { fontWeight: 700, textAlign: 'right' }, // Bold
    contentTitle: { fontWeight: 700 }, // Bold
    headerSection: { marginBottom: 5 },
    headerRow: {
      flexDirection: 'row',
      justifyContent: 'space-between',
      alignItems: 'center',
    },
    headerColumn: { flexDirection: 'row', alignItems: 'center', flex: 1 },
    divider: {
      borderBottomWidth: 1,
      borderBottomColor: '#000',
      borderBottomStyle: 'solid',
      marginBottom: 5,
    },
    divider2: {
      borderBottomWidth: 1,
      borderBottomColor: '#000',
      borderBottomStyle: 'solid',
      marginBottom: 5,
    },
    divider3: {
      borderBottomWidth: 1,
      borderBottomColor: '#000',
      borderBottomStyle: 'solid',
    },
    label: { fontWeight: 300, marginRight: 5 }, // Light
    value: { fontWeight: 700, marginLeft: 5 }, // Bold
    tableTitle: { flexDirection: 'row', alignItems: 'center', marginBottom: 5 },
    table: {
      width: 'auto',
      // borderStyle: 'solid',
      // borderWidth: 1,
      borderColor: '#bfbfbf',
    },
    tableRow: { flexDirection: 'row' },
    colHeader: {
      width: '25%',
      // borderStyle: 'solid',
      // borderWidth: 1,
      // borderColor: '#bfbfbf',
      backgroundColor: paperBg,
      textAlign: 'center',
      padding: 2,
    },
    tableCol: {
      width: '25%',
      // borderStyle: 'solid',
      // borderWidth: 1,
      // borderColor: '#bfbfbf',
      textAlign: 'center',
      padding: 2,
    },
    tableCellHeader: { fontSize: 8, fontWeight: 700 }, // Light
    tableCell: { fontSize: 8, fontWeight: 300 }, // Bold
    arHeaderSection: { marginTop: 5, marginBottom: 5 },
    arHeaderSectionRow: { flexDirection: 'row', justifyContent: 'flex-end' },
    arHeaderRow: { flexDirection: 'row', justifyContent: 'space-between' },
    arHeaderColumn: {
      flexDirection: 'column',
      justifyContent: 'space-between',
      alignItems: 'center',
    },
    arHeaderColumnLabel: {
      flexDirection: 'column',
      justifyContent: 'space-between',
      alignItems: 'center',
    },
    arHeaderColumnValue: {
      flexDirection: 'column',
      justifyContent: 'space-between',
      alignItems: 'flex-start',
    },
    arBodySection: { marginTop: 5, marginBottom: 5 },
    arBodySectionRow: { flexDirection: 'row', justifyContent: 'flex-end' },
    arBodyRow: { flexDirection: 'row', justifyContent: 'space-between' },
    arBodyColumn: {
      flexDirection: 'column',
      justifyContent: 'space-between',
      width: '75%',
    },
    arBodyColumnLabel: {
      flexDirection: 'column',
      justifyContent: 'space-between',
      alignItems: 'flex-start',
    },
    arBodyColumnValue: {
      flexDirection: 'column',
      justifyContent: 'space-between',
      alignItems: 'flex-start',
    },
    signatureAuthRow: { flexDirection: 'row', justifyContent: 'space-between' },
    signatureColumn: {
      flexDirection: 'column',
      justifyContent: 'space-between',
      width: '40%',
    },
    signatureColumnLabel: {
      flexDirection: 'column',
      justifyContent: 'space-between',
      alignItems: 'flex-start',
    },
    signatureColumnValue: {
      flexDirection: 'column',
      justifyContent: 'space-between',
      alignItems: 'center',
    },
    amountValue: { fontWeight: 700 }, // Bold
    footer: {
      position: 'absolute',
      fontSize: 8,
      bottom: 30,
      left: 0,
      right: 0,
      textAlign: 'center',
    },
  });

  const VoucherDocument = () => (
    <Document>
      {cmDetails.map((cmDetails, index) => (
        <Page key={index} size='A4' style={styles.page}>
          {/* Header Section */}
          <View>
            {/* <View style={{ display: 'flex', flexDirection: 'row', justifyContent: 'space-between', alignItems: 'center' }}> */}
            {/* <Image src="path/to/image.png" style={{ width: 100 }} /> */}
            <View style={{ marginBottom: 15 }}>
              <Text style={styles.title}> {propertyDetails.propertyName}</Text>
              {/* <Text style={styles.subTitle}>
              Owned and Managed by: SAMPLE HOTEL.
            </Text> */}
              <Text style={styles.subTitle}>
                {propertyDetails.propertyAddress}
              </Text>
              <Text style={styles.subTitle}>
                {propertyDetails.propertyEmail}
              </Text>
              <Text style={styles.subTitle}>
                {`${busRegType} TIN: ${busTin}`}
              </Text>
            </View>
            <View>
              <Text style={styles.title}>
                {'CREDIT MEMO '}
                {cmDetails.transNo}
              </Text>
            </View>
          </View>
          <View style={styles.divider}></View>
          {/* Content Section */}
          <View style={styles.arHeaderSection}>
            <View style={styles.arHeaderColumn}>
              <Text style={styles.label}>Received from</Text>
              <Text style={styles.contentTitle}>{cmDetails.guestName} </Text>
              <Text style={styles.label}>the credit amount of</Text>
              <Text style={styles.contentTitle}>
                {formatNumber(cmDetails.creditAmount, 2, 2)}
              </Text>
              <Text style={styles.contentTitle}>
                ({toWords.convert(cmDetails.creditAmount).toUpperCase()}
                ).
              </Text>
            </View>
          </View>
          <View style={styles.divider2}></View>
          <View style={styles.table}>
            {/* Table Header */}
            <View style={styles.tableRow}>
              <View style={styles.colHeader}>
                <Text style={styles.tableCellHeader}>Tender</Text>
              </View>
              <View style={styles.colHeader}>
                <Text style={styles.tableCellHeader}>Cashier</Text>
              </View>
              <View style={styles.colHeader}>
                <Text style={styles.tableCellHeader}>Printed Date & Time</Text>
              </View>
              <View style={styles.colHeader}>
                <Text style={styles.tableCellHeader}>Remarks</Text>
              </View>
            </View>
            {/* Table Row */}
            <View style={styles.tableRow}>
              <View style={styles.tableCol}>
                <Text style={styles.tableCell}>{'Credit Memo'}</Text>
              </View>
              <View style={styles.tableCol}>
                <Text style={styles.tableCell}>{cmDetails.staffName}</Text>
              </View>
              <View style={styles.tableCol}>
                <Text style={styles.tableCell}>{printedDate}</Text>
              </View>
              <View style={styles.tableCol}>
                <Text style={styles.tableCell}>{cmDetails.bookingDetails}</Text>
              </View>
            </View>
            {/* Additional Rows as needed */}
          </View>
          <View style={[styles.divider2, { marginTop: 5 }]}></View>
          <View style={styles.arBodySection}>
            <View style={styles.arBodyRow}>
              {/* <View style={styles.signatureColumn}>
              <View style={[styles.signatureAuthRow, {marginBottom: 50}]}>
                <View style={styles.signatureColumnLabel}>
                  <Text style={styles.label}>Authorized Representative:</Text>
                </View>
              </View>
              <View style={styles.divider3}></View>
              <View>
                <View style={styles.signatureColumnValue}>
                  <Text style={styles.label}>Printed Name & Signature</Text>
                </View>
              </View>
            </View> */}
            </View>
          </View>
          <View style={styles.arHeaderSection}>
            <View style={styles.arHeaderColumn}>
              <Text style={styles.contentTitle}>
                *** THIS DOCUMENT IS NOT VALID FOR CLAIM OF INPUT TAX ***
              </Text>
            </View>
          </View>
          <View style={[styles.divider2, { marginTop: 5 }]}></View>
        </Page>
      ))}
    </Document>
  );

  return (
    <Modal
      open={isOpen}
      onClose={handleCloseClick}
      aria-labelledby='AcknowledgmentReceipt'
      aria-describedby='AcknowledgmentReceipt'
    >
      <Stack
        sx={{
          position: 'absolute',
          top: '50%',
          left: '50%',
          transform: 'translate(-50%, -50%)',
          width: '100%', // Set width to 90% of the viewport width
          maxWidth: '1000px', // Limit maximum width to 1214 pixels
          bgcolor: paperBg,
          boxShadow: 24,
          overflow: 'auto', // Add overflow property to enable scrolling when content overflows
          '@media (max-width: 600px)': {
            width: '95%', // Adjust width for smaller screens
            maxWidth: '100%', // Remove max width restriction for smaller screens
            height: '80vh', // Adjust height for smaller screens
            maxHeight: 'none', // Remove max height restriction for smaller screens
          },
        }}
      >
        {/* {isError ? (
          <ServerError />
        ) : (
          
        )} */}
        <Box>
          <IconButton
            onClick={handleCloseClick}
            sx={{
              position: 'absolute',
              top: 20,
              right: 15,
              zIndex: 1,
            }}
          >
            <CloseIcon />
          </IconButton>

          {/* Header */}

          <Stack>
            <Box sx={{ p: '20px', borderBottom: '1px solid #EEE' }}>
              <ContainerTitle
                title={'Credit Memo'}
                func={() => {}}
                titleStyle={{ fontSize: '20px!important' }}
              />
            </Box>
          </Stack>

          {/*Details*/}
          {cmDetails.length === 0 ? (
            <Box
              sx={{
                p: '0 24px 24px 24px',
                height: '82vh',
                width: '100%',
              }}
            >
              <LoadingComponent />
            </Box>
          ) : (
            <Stack direction='row' width='100%'>
              <PDFViewer style={{ width: '100%', height: '82vh' }}>
                <VoucherDocument />
              </PDFViewer>
            </Stack>
          )}
        </Box>
      </Stack>
    </Modal>
  );
};
export default CreditMemoVoucher;
